<template>
  <div class="step-flow">
    <div
      v-for="step in steps"
      :key="step.number"
      class="step-element"
      :class="{
        active: step.number === currentStep,
        done: step.number < currentStep,
      }"
      @click="goToStep(step.number)"
    >
      <div class="circle-line-container">
        <div class="circle">
          <span v-if="step.number < currentStep" class="done-icon">✔</span>
          <span v-else>{{ step.number }}</span>
        </div>
        <div v-if="step.number < steps.length" class="line"></div>
      </div>
      <div class="circle-line-container">
        <div class="label">{{ step.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepsBar",
  props: {
    steps: {
      type: Array,
      required: true,
    },
    currentStep: {
      type: Number,
      required: true,
    },
  },
  methods: {
    goToStep(stepNumber) {
      this.$emit("step-clicked", stepNumber); // Emit an event when a step is clicked
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/global/colors.scss";

/* Step Flow */
.step-flow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background-color: transparent;
  /* Optional: Add a background for the step flow */
  /* border-bottom: 1px solid #ddd; */
  /* Optional: Add a separator line */
}

/* Step */
.step-element {
  display: flex;
  flex-direction: column;
  /* Stack items vertically */
  align-items: center;
  /* Center align the circle and label */
  position: relative;
  cursor: pointer;
  flex: 1;
  /* Ensure equal spacing between steps */
}

/* Circle and Line Container */
.circle-line-container {
  display: flex;
  align-items: center;
  width: 100%;
  /* Ensure the line stretches between circles */
}

.circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ffffff;
  /* White background for circles */
  border: 2px solid $selection-color;
  /* Orange border for inactive steps */
  color: $selection-color;
  /* Orange color for numbers */
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  z-index: 1;
  /* Ensure circles are above the line */
}

.step-element.active .circle {
  border-color: $brand-dark;
  /* Green border for active step */
  color: $brand-dark;
  /* Green color for active step number */
}

.step-element.done .circle {
  background-color: $brand-dark;
  color: white;
  border-color: $brand-dark;
}

.done-icon {
  font-size: 18px;
}

.line {
  flex: 1;
  /* Fill the space between circles */
  height: 4px;
  background-color: $selection-color;
  /* Orange for timeline */
  margin-left: -2px;
  /* Align with circle border */
  margin-right: -2px;
  /* Align with circle border */
  z-index: 0;
  /* Ensure the line is behind the circles */
}

.step-element.done .line {
  background-color: $brand-dark;
  /* Green for completed timeline */
}

.label {
  margin-top: 8px;
  /* Add spacing between the circle and the label */
  text-align: center;
  font-size: 14px;
  color: $selection-color;
  /* Orange for inactive steps */
}

.step-element.active .label {
  color: $brand-dark;
  /* Green for active step */
}

.step-element.done .label {
  color: black;
  /* Green for completed steps */
}
</style>
